import {Component, Input} from "@angular/core";

@Component({
    selector: "publick-calculator-v2-title",
    templateUrl: "./publick-calculator-v2-title.component.html",
    moduleId: module.id.toString()
})


export class PublicCalculatorV2TitleComponent {

    @Input() public title: string;
    @Input() public note: string;
    @Input() public showTitle: boolean = true;
    @Input() public showNote: boolean = true;
    constructor() {
    }
}



// WEBPACK FOOTER //
// ./app/components/common/publick-calculator-v2-title/publick-calculator-v2-title.component.ts